import {
  ID,
  IDPrefixes,
  MinimalRelationship,
  PrefixedID,
  Relationship,
  Task,
} from '@griply/types';
import { createPrefixId } from '@griply/utils';

export type UpdateLinkedRelationshipsOptions = {
  taskPairs: Array<{ oldTask: Task; newTask: Task }>;
  relationships: Relationship[];
  updateRelationshipReferences: (
    relationships: MinimalRelationship[],
  ) => Promise<void> | void;
};

export const updateLinkedRelationships = async ({
  taskPairs,
  relationships,
  updateRelationshipReferences,
}: UpdateLinkedRelationshipsOptions): Promise<void> => {
  const oldToNewTaskIdMap = new Map<ID, ID>();
  taskPairs.forEach(({ oldTask, newTask }) => {
    if (oldTask.parentIds?.length) {
      return;
    }
    oldToNewTaskIdMap.set(oldTask.id, newTask.id);
  });

  if (!oldToNewTaskIdMap.size) {
    return;
  }

  const relationshipUpdates = new Map<PrefixedID, MinimalRelationship>();
  oldToNewTaskIdMap.forEach((newTaskId, oldTaskId) => {
    const taskRelationshipId = createPrefixId(oldTaskId, IDPrefixes.Task);
    const newTaskRelationshipId = createPrefixId(newTaskId, IDPrefixes.Task);

    relationships.forEach((relationship) => {
      if (!relationship.references.includes(taskRelationshipId)) {
        return;
      }

      const existing = relationshipUpdates.get(relationship.id);
      if (existing) {
        if (!existing.references.includes(newTaskRelationshipId)) {
          existing.references.push(newTaskRelationshipId);
        }
        return;
      }

      relationshipUpdates.set(relationship.id, {
        id: relationship.id,
        references: [...relationship.references, newTaskRelationshipId],
      });
    });
  });

  if (!relationshipUpdates.size) {
    return;
  }

  await updateRelationshipReferences(Array.from(relationshipUpdates.values()));
};
